import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../components/context/auth/AuthState";
import { JoinCommunityServer } from "../components/backendRequests/functionUtils";
import { useData } from "../components/context/data/DataState";
import SearchCommunity from "../components/user/SearchCommunity";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Alert, AlertDescription } from "../components/ui/alert";
import { UserPlus, AlertCircle, CheckCircle2 } from "lucide-react";

const JoinCommunity = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { updateData, changeCommunityId } = useData();
  const [communityCode, setcommunityCode] = useState("");
  const [status, setstatus] = useState({
    severity: "",
    title: "",
    msg: "",
    display: false,
  });

  const { currentUser } = useAuth();

  useEffect(() => {
    if (status.display === false) return;
    setTimeout(() => {
      setstatus((prev) => ({
        ...prev,
        display: false,
      }));
    }, 5000);
  }, [status]);

  useEffect(() => {
    if (id) {
      setcommunityCode(id);
    }
  }, []);

  const handleJoinCommunity = async (code = communityCode) => {
    if (currentUser) {
      const joinresult = JoinCommunityServer(
        code,
        currentUser.user_id,
        "Member"
      )
        .then((res) => {
          if (res.ok) {
            setstatus((prev) => ({
              ...prev,
              severity: "success",
              title: "Success",
              msg: "Joined Community Successfully",
              display: true,
            }));
            updateData().then(() => {
              if (res.communityId) changeCommunityId(res.communityId);
            });
            navigate("/");
          } else {
            setstatus((prev) => ({
              ...prev,
              severity: "error",
              title: "Error",
              msg: res.data,
              display: true,
            }));
            return null;
          }
        })
        .catch((err) => {
          console.log(err);
          return null;
        });
    } else {
      navigate(`/signup/${communityCode}`);
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-6 space-y-6">
      <div className="text-center">
        <h1 className="text-3xl font-bold mb-2">Join a Community</h1>
      </div>

      <div className="space-y-4">
        <div className="flex gap-2">
          <Input
            placeholder="Enter community code"
            value={communityCode}
            onChange={(e) => setcommunityCode(e.target.value)}
            className="flex-1"
          />
          <Button
            onClick={() => handleJoinCommunity()}
            className="gap-2"
          >
            <UserPlus className="h-4 w-4" />
            Join
          </Button>
        </div>

        {status.display && (
          <Alert variant={status.severity === "error" ? "destructive" : "success"}>
            {status.severity === "error" ? (
              <AlertCircle className="h-4 w-4" />
            ) : (
              <CheckCircle2 className="h-4 w-4" />
            )}
            <AlertDescription>{status.msg}</AlertDescription>
          </Alert>
        )}
      </div>

      {!id && (
        <div>
          <SearchCommunity handleJoinCommunity={handleJoinCommunity} />
        </div>
      )}
    </div>
  );
};

export default JoinCommunity;
